import { executePost } from "../../../Utils/ServiceMethods";
import { toast } from "react-toastify";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { CityId, removeUserCredentials } from "../../../Utils/LocalStorage";

export const InsertChatApi = async (MessageData, cb) => {
  const id = CityId();
  //   const endUser_Id = enduserId();

  try {
    const insertMessage = await executePost("/chat/message", {
      api_method: "post",
      eu_id: MessageData.endUser_Id,
      channel_id: MessageData.channel_id,
      product_id: parseInt(MessageData.product_id),
      product_type: MessageData.product_type,
      help_reason: MessageData.help_reason,
      marketplace_business_id: parseInt(MessageData.marketplace_business_id),
      mms_city_id: parseInt(id),
    });
    const insertMessageData = insertMessage.data ? insertMessage.data : {};
    console.log(insertMessage);
    return insertMessageData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
